import TechSupportContent from "../../../../src/pages/faq/tech-support-content.md";
import * as React from 'react';
export default {
  TechSupportContent,
  React
};